import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWebcam = (props) => /* @__PURE__ */ _jsxs("svg", {
	...props,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 1.66666,
			height: 3.41188,
			rx: .5,
			transform: "matrix(0.706757 -0.707457 0.707452 0.706761 6.67871 17.1896)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5002 14.1416V17.9445M14.9766 13.9562L16.878 15.8577C16.9968 15.9763 17.1578 16.043 17.3257 16.0431H21.5002",
			stroke: "#111113",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.54608 15.7731C3.52405 15.7952 3.50907 15.8234 3.50301 15.8541C3.49695 15.8847 3.50009 15.9165 3.51202 15.9453C3.52396 15.9742 3.54417 15.9989 3.57011 16.0163C3.59604 16.0338 3.62655 16.0431 3.65779 16.0433H7.04004L10.023 19.027C10.0819 19.0859 10.1518 19.1327 10.2287 19.1646C10.3056 19.1965 10.3881 19.2129 10.4714 19.2129C10.5547 19.2129 10.6372 19.1965 10.7141 19.1646C10.7911 19.1327 10.861 19.0859 10.9199 19.027L20.4272 9.51957C20.4862 9.4607 20.5329 9.3908 20.5648 9.31385C20.5967 9.23691 20.6131 9.15443 20.6131 9.07113C20.6131 8.98784 20.5967 8.90536 20.5648 8.82842C20.5329 8.75147 20.4862 8.68156 20.4272 8.6227L15.9905 4.18589C15.9316 4.12696 15.8617 4.08021 15.7847 4.04831C15.7078 4.01642 15.6253 4 15.542 4C15.4587 4 15.3763 4.01642 15.2993 4.04831C15.2224 4.08021 15.1525 4.12696 15.0936 4.18589L3.54608 15.7731Z",
			fill: "#595959"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.54608 15.7731C3.52405 15.7952 3.50907 15.8234 3.50301 15.8541C3.49695 15.8847 3.50009 15.9165 3.51202 15.9453C3.52396 15.9742 3.54417 15.9989 3.57011 16.0163C3.59604 16.0338 3.62655 16.0431 3.65779 16.0433H7.04004L7.69819 16.7018L18.1024 6.29749L15.9905 4.18589C15.9316 4.12696 15.8617 4.08021 15.7847 4.04831C15.7078 4.01642 15.6253 4 15.542 4C15.4587 4 15.3763 4.01642 15.2993 4.04831C15.2224 4.08021 15.1525 4.12696 15.0936 4.18589L3.54608 15.7731Z",
			fill: "#413F3F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.04004 16.0433L17.4435 5.63974L15.9905 4.18589C15.9316 4.12696 15.8617 4.08021 15.7847 4.04831C15.7078 4.01642 15.6253 4 15.542 4C15.4587 4 15.3763 4.01642 15.2993 4.04831C15.2224 4.08021 15.1525 4.12696 15.0936 4.18589L3.54608 15.7731C3.52405 15.7952 3.50907 15.8234 3.50301 15.8541C3.49695 15.8847 3.50009 15.9165 3.51202 15.9453C3.52396 15.9742 3.54417 15.9989 3.57011 16.0163C3.59604 16.0338 3.62655 16.0431 3.65779 16.0433H7.04004Z",
			fill: "#111113"
		})
	]
});
export default SvgWebcam;
